export const PAGE_PADDING_X = { xs: 2, sm: 2, md: 2, lg: 2.5, xl: 3 };

export const PAGE_PADDING_X_NEGATIVE = { xs: -2, sm: -2, md: -2, lg: -2.5, xl: -3 };
